import React from 'react';

const HpRespRecentlyViewedItems = React.lazy(() =>
    import(/* webpackChunkName: "HpRespRecentlyViewedItems" */ './HpRespRecentlyViewedItems')
);

export function HpRespRecentlyViewedItemsLoader(props) {
    return (
        <React.Suspense fallback={null}>
            <HpRespRecentlyViewedItems {...props} />
        </React.Suspense>
    );
}
